import { render, staticRenderFns } from "./discounts-products.vue?vue&type=template&id=d49e5192&"
import script from "./discounts-products.vue?vue&type=script&lang=js&"
export * from "./discounts-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports